import {EnvHelper} from '@/helpers/EnvHelper'
import axios from 'axios'

type TGasbotStatistics = {
  totalServers: number
  holdingWallets: number
  totalWallets: number
  totalTokens: {[hash: string]: string}
  tokenWallets: {[hash: string]: number}
}

export class GasbotHelper {
  static fetchStatistics = async (): Promise<TGasbotStatistics> => {
    const {data} = (await axios.get<TGasbotStatistics>(
      EnvHelper.VUE_APP_GASBOT_URL + '/api/statistics'
    )) as {data: TGasbotStatistics}

    return data
  }
}
